import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {Reports} from '/constant/TestIDs';
import {CLIENT_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_ORDER_HISTORY} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {NewFrontlineClientsContent} from './NewFrontlineClientsContent';
import reportPayload from './reportPayload';

export const NewFrontlineClientsReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      testID={Reports.reportNewFrontlineClient}
      title={tt('title', 'New Frontline Clients')}
      description={tt(
        'description',
        "New Clients you've added to your Frontline this month.",
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={NewFrontlineClientsContent}
    />
  );
};

export default withHOC(
  withTranslation('report.newFrontlineClients'),
  withRecordPopover({
    reportPayload,
    popoverName: CLIENT_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_ORDER_HISTORY,
    popoverContentProps: {
      renderTitle: () =>
        withTranslation.ts('reportRecordTitle.orderHistory', 'Order History'),
    },
  }),
)(NewFrontlineClientsReport);
